export const ROLES = {
  owner: 1,
  employee: 2,
  admin: 3,
};
